import ApiService from './api.service.js';

export default {
  fetchAdmins(params) {
    return ApiService.get(`/admins`, { params });
  },
  getAdminData(adminId) {
    return ApiService.get(`/admins/${adminId}`);
  },
  updateAdmin(admin) {
    return ApiService.put(`/admins/${admin.id}`, JSON.stringify(admin));
  },
  createAdmin(data) {
    return ApiService.post(`/admins`, JSON.stringify(data));
  }
};
